import { ITEM_MESSAGES } from '@palaccount/contracts';

/**
 * ── RECOGNISING BR-MD-05-08's QUESTION IN A SERVER MESSAGE ─────────────────
 *
 * ERR-MD-05-03 is the one refusal in the item form that is a QUESTION rather
 * than a verdict: "45.0000 is below the 30.0000 cost of Cotton T-Shirt —
 * Premium. Continue?" A Manager answers it and re-sends; everybody else reads
 * it and raises the price. The form therefore has to tell it apart from every
 * other refusal, and it arrives as a sentence, because the API returns
 * sentences (server-messages.ts records that trade: "the parameterised
 * sentences … pass through in English … until the API returns message codes").
 *
 * THE MARKER IS THE TRAILING QUESTION, taken FROM the contract rather than
 * retyped here, so a reword of `belowCost`/`belowCostHidden` moves this with
 * it. Both variants end the same way, which is what makes one test enough for
 * both. `below-cost.test.ts` pins the other half — that NO other
 * ITEM_MESSAGES sentence ends this way — because that is the property this
 * predicate actually depends on, and the one a future message could break
 * without touching this file.
 *
 * A false positive would be the expensive direction: it would turn some other
 * refusal into a Continue button. The suffix is a full sentence-ending
 * question mark on a message set whose other members are all statements, and
 * the test keeps it that way.
 */
export const BELOW_COST_SUFFIX = ITEM_MESSAGES.belowCostHidden('x').slice(
  ITEM_MESSAGES.belowCostHidden('x').lastIndexOf('.'),
);

export function isBelowCostQuestion(message: string): boolean {
  return message.endsWith(BELOW_COST_SUFFIX);
}
